"use client";
import { GlobalContextProvider } from "@/contexts/global";
import { Lang } from "@/i18n/settings";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";
import NavBar from "../common/navbar";
import { getQueryClient } from "./get-query-client";
import { ThemeProvider } from "./theme-provider";
import { Toaster } from "../ui/sonner";

export function Providers({ children, lang }: { children: React.ReactNode; lang: Lang }) {
  const queryClient = getQueryClient();

  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        <GlobalContextProvider>
          <NavBar lang={lang} />

          {children}
          <Toaster />
        </GlobalContextProvider>
        <ProgressBar height="4px" options={{ showSpinner: false }} shallowRouting color="#F3D5A9" />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
